import * as common from 'assets/core/js/common'
import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import EventManager from 'assets/core/js/module/eventManager'
import SearchFiltersRecap, { addListenerToUpdateWithSearchFilters } from 'assets/themes/campings/js/module/searchFiltersRecap'
import type SidePanel from '@design/objects/sidePanel/twig/assets'

export default function (): void {
  if (document.getElementById('filter-offers')) {
    initSearchFiltersRecap()
  }

  const recapOpenFiltersEl = document.getElementById('recap-open-filters')
  const recapOpenSearchEl = document.getElementById('recap-open-search')
  const recapGoBackEl = document.getElementById('recap-go-back') as HTMLAnchorElement | null

  if (recapOpenFiltersEl) {
    EventManager.addEvent('recap-open-filters', recapOpenFiltersEl, 'click', (e) => {
      e.preventDefault()
      openSearchFiltersSidePanel('filters')
    })
  }

  if (recapOpenSearchEl) {
    EventManager.addEvent('recap-open-search', recapOpenSearchEl, 'click', (e) => {
      e.preventDefault()
      openSearchFiltersSidePanel('search')
    })
  }

  if (recapGoBackEl) {
    try {
      const referrerUrl = new URL(document.referrer)

      if (referrerUrl.hostname === document.location.hostname) {
        recapGoBackEl.href = document.referrer
      } else {
        recapGoBackEl.style.visibility = 'hidden'
      }
    } catch {
      recapGoBackEl.style.visibility = 'hidden'
    }
  }

  const containersToUpdate = [...document.querySelectorAll('.product__search')]
  containersToUpdate.forEach((containerToUpdate) => {
    addListenerToUpdateWithSearchFilters(containerToUpdate)
  })

  if (document.querySelector('.product__search .product-search__recap-inline')) {
    EventManager.addEvent(
      'product__search',
      document.querySelector('.product__search .product-search__recap-inline') as HTMLElement,
      'click',
      (e) => {
        e.preventDefault()
        openSearchFiltersSidePanel('search')
      }
    )
  }
}

export function openSearchFiltersSidePanel(tabTarget = 'search'): void {
  const sidePanelEl = document.getElementById('filters-side-panel')

  if (!sidePanelEl) {
    return
  }

  const sidePanel = ElementPropertiesManager.getProperty<SidePanel>(sidePanelEl, 'sidePanel')

  if (!sidePanel) {
    return
  }

  sidePanel.open()
  sidePanel.getElement().querySelector<HTMLElement>(`.tab__item[data-target="${tabTarget}"]`)?.click()
}

function initSearchFiltersRecap(): void {
  const filterOffersEl = document.getElementById('filter-offers')

  if (!filterOffersEl) {
    return
  }

  SearchFiltersRecap(filterOffersEl, '#filters-sort input[name^="filter_offers"]:not([name="filter_offers[budgets]"])', undefined, function (el) {
    if (!common.isMobile() && !common.isTablet()) {
      return
    }

    if (!el || el.getAttribute('data-type') === 'search') {
      openSearchFiltersSidePanel('search')
    }

    if (el && el.getAttribute('data-type') === 'filters') {
      openSearchFiltersSidePanel('filters')
    }
  })
}
